<template>
  <section class="showcase">
			<div class="video-container">
				<video src="../assets/BG_2.mp4" autoplay muted loop></video>
			</div>
			<div class="content">
				<h1>APRAMEYA </h1>
				<h3>The Autonomous Systems Club</h3>
				<a href="#about" class="btn">Explore now</a>
			</div>
		</section>


		<section id="about">
			<h1>About</h1>
			<p>
				This Autonomous vehicles Club is a student-run organization dedicated to the exploration, development, and application of autonomous vehicle's technology. We are passionate about the potential of autonomous vehicles to revolutionize many aspects of our lives, from transportation and manufacturing to healthcare and agriculture

This club also provides the members with opportunities to network with professionals in the field and to get involved in cutting-edge research projects. We are committed to supporting our members in their pursuit of careers in autonomous vehicles and to helping them make a positive impact on the world.

The club is open to students from all majors and experience levels. We offer a variety of activities and events to help members learn about and contribute to the field of autonomous systems. 
These activities include:
->Weekly meetings where we discuss research papers, give presentations, and work on projects, Workshops and tutorials on various aspects of autonomous systems technologies such as robotics, computer vision, and machine learning
->Field trips to visit companies and research labs that are developing autonomous systems , Participation in hackathons and other competitions related to autonomous systems

This Autonomous Systems Club has the potential to be a valuable resource for students who are interested in this exciting and rapidly developing field. By extending the club's reach and impact, we can help to shape the future of autonomous systems technology and make a difference in the world.
			</p>

			<h2>Follow Us on Social Media</h2>

			<div class="social">
        
        <a href="https://twitter.com/aprameya_klu" target="_blank"><img src="../assets/twitter.webp" alt="Twitter"></a>
        <a href="https://www.instagram.com/aprameya_klu/" target="_blank"><img src="../assets/insta.avif" alt="Instagram"></a>
        <a href="https://in.linkedin.com/company/aprameya-club" target="_blank"><img src="../assets/linkedin_1.webp" alt="linkedin"></a>
			</div>
		</section>    
</template>
  
  <script>
 export default {
  name: 'HomePage',
  mounted() {
    // Smooth scroll when clicking on the "Read More" button
    document.querySelector('.btn').addEventListener('click', function (e) {
      e.preventDefault();
      const aboutSection = document.getElementById('about');
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    });
  },
};
  </script>
  
  <style scoped>
  @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400&display=swap');

:root {
	--primary-color: white;
}

* {
	box-sizing: border-box;
	margin: 0;
	padding: 0;
}

body {
	font-family: 'Open Sans', sans-serif;
	line-height: 1.5;
  scroll-behavior: smooth;
}
@import url(https://fonts.googleapis.com/css?family=Istok+Web);
@keyframes slidy {
0% { left: 0%; }
20% { left: 0%; }
25% { left: -100%; }
45% { left: -100%; }
50% { left: -200%; }
70% { left: -200%; }
75% { left: -300%; }
95% { left: -300%; }
100% { left: -400%; }
}
* {
  box-sizing: border-box;
}
body, figure { 
  margin: 0;
  font-family: Istok Web, sans-serif;
  font-weight: 100;
  
}

div#captioned-gallery { 
  width: 100%; overflow: hidden; 
}
figure.slider { 
  position: relative; width: 500%;
  font-size: 0; animation: 30s slidy infinite; 
}
figure.slider figure { 
  width: 20%; height: auto;
  display: inline-block;  position: inherit; 
  object-fit: cover;
}
figure.slider img { 
  width: 50%; height:50%; object-fit: cover; 
  margin: 10px;
  cursor: pointer;
}
figure.slider figure figcaption { 
  position: absolute; bottom: 0;
  color: #fff; width: 100%;
  font-size: 2rem; padding: .6rem; 
}


a {
	text-decoration: none;
	color: var(--primary-color);
}

.showcase {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #fff;
  padding: 0 20px;
  position: relative;
  background: linear-gradient(to bottom, #1d3561, #243b55); /* Gradient background */
}

h1 {
  font-weight: 700;
  font-size: 8rem; /* Adjust font size */
  margin-bottom: 10px;
}

h3 {
  font-size: 2rem; /* Adjust font size */
  margin-bottom: 20px;
}

.video-container {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	overflow: hidden;
	background: var(--primary-color) url('https://s.tmimgcdn.com/scr/800x500/345800/bg--dark-blue-background-blue-texture-background_345824-original.jpg') no-repeat center
		center/cover;
}

.video-container video {
	min-width: 100%;
	min-height: 100%;
  position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	object-fit: cover;
}

.video-container:after {
  content: '';
  z-index: 1;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  position: absolute;
  background: rgba(0, 0, 0, 0.5); /* Add a semi-transparent overlay */
}


.content {
	z-index: 2;
}

.btn {
  display: inline-block;
  padding: 10px 30px;
  background: linear-gradient(to bottom right,  rgba(104, 133, 226, 0.125), rgb(0, 0, 0)); /* Gradient background */
  color: #ffffff92;
  border-radius: 5px;
  border: none;
  margin-top: 25px;
  opacity: 0.9;
  font-weight: 700;
  transition: transform 0.3s ease-in-out;
}

.btn:hover {
  transform: scale(1.05);
  color: #fff; /* Add a subtle hover effect */
  background: linear-gradient(to bottom right,  rgba(104, 133, 226, 0.125), rgb(4, 16, 153));;
}
#about {
  padding: 40px;
  text-align: justify;
  background: #fff; /* Background color */
  color: #333; /* Text color */
}

#about h1 {
  font-size: 2.5rem; /* Adjust font size */
  text-align: center;
}

#about p {
  font-size: 1.2rem;
  line-height: 1.6; /* Increase line height */
  max-width: 800px;
  margin: auto;
}

#about h2 {
  margin: 30px 0;
  color: #3498db; /* Heading color */
  text-align: center;
}

.social{
  display: flex;
      justify-content: space-around;
      align-items: center;
      margin: 20px;
}
.social a{
  text-decoration: none;
      color: #333;
      font-size: 24px;
      margin: 0 10px;
}
.social img{
  width: 60px;
  height: auto;
}

@media (max-width: 800px) {
    h1 {
      font-size: 60px; /* Adjust font size for smaller screens */
    }

    h3 {
      font-size: 20px; /* Adjust font size for smaller screens */
    }

    .showcase {
      height: 80;
      padding: 20px;
    }

    .video-container video {
      min-width: 100%;
      min-height: 100%;
      position: relative; /* Adjust video positioning for smaller screens */
      transform: translate(-50%, -50%);
    }

    .content {
      text-align: center;
    }

    .btn {
      margin-top: 15px; /* Adjust margin for smaller screens */
    }

    #about {
      padding: 20px;
    }

    #about h1 {
      font-size: 60px; /* Adjust font size for smaller screens */
    }

    #about p {
      font-size: 1rem; /* Adjust font size for smaller screens */
    }

    #about h2 {
      font-size: 20px; /* Adjust font size for smaller screens */
    }

    .social {
      flex-direction: column; /* Arrange social links in a column for smaller screens */
      margin: 10px 0;
    }

    .social a {
      margin: 5px 0; /* Adjust margin between social links for smaller screens */
    }
  }
  </style>
  